import { Typography } from "@/frontend/shared/ui/Typography";

export function SectionTitle({ children }: { children: string }) {
  return (
    <Typography variant="heading-6" color="greyscale700">
      {children}
    </Typography>
  );
}
